export default function Configure($stateProvider) {
    $stateProvider.state('societes-auditeur', {
        parent: 'common',
        url: '/societes-auditeur',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('societes-auditeur.list', {
        url: '/list',
        template: '<societes></societes>',
        rights: { domain: 'societes', right: 'read', application: 'qse' },
        params: {
            genre: '256'
        },
        ncyBreadcrumb: {
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETES_AUDITEUR_LIST" | translate}}'
        },
        navigation: {
            menu: 'donnees_parametres_donnees',
            translate: 'SOCIETES.BREADCRUMBS.SOCIETES_AUDITEUR_LIST',
            order: 1
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETES_AUDITEUR_LIST'
    });

    $stateProvider.state('societes-auditeur.niveaux', {
        url: '/niveaux',
        template: '<societe-config-niveaux></societe-config-niveaux>',
        rights: { domain: 'nivh', right: 'read' },
        params: {
            genre: '256'
        },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher societes > niveaux
            parent: 'societes-auditeur.list({genre: "256"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_NIVEAUX" | translate }}'
        }
    });

    $stateProvider.state('societes-auditeur.list.detail', {
        url: '/{id}',
        template: '<societe-detail></societe-detail>',
        rights: { domain: 'societes', right: 'read' },
        params: {
            genre: '256'
        },
        ncyBreadcrumb: {
            parent: 'societes-auditeur.list({genre: "256"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('societes-auditeur.new', {
        url: '/new',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'create' },
        params: {
            genre: '256'
        },
        ncyBreadcrumb: {
            parent: 'societes-auditeur.list({genre: "256"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_AUDITEUR_NEW" | translate}}'
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETE_AUDITEUR_NEW'
    });

    $stateProvider.state('societes-auditeur.edit', {
        url: '/{id}/edit',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'update' },
        params: {
            genre: '256'
        },
        ncyBreadcrumb: {
            parent: 'societes-auditeur.list({genre: "256"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_AUDITEUR_EDIT" | translate }}'
        }
    });

    $stateProvider.state('societes-auditeur.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: {
            parentState: 'societes-auditeur.new',
            genre: '256'
        },
        ncyBreadcrumb: {
            parent: 'societes-auditeur.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
